module.exports = __webpack_public_path__ + "r-v3/img/ico_noise_white.e3b535ed.svg";